import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
const inProductSingleFilter = product => v => {
  if (v.tag === "ItemIdFilter") {
    return Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v$1 => v1 => v$1 || v1})})((() => {
      const $0 = product.itemId;
      return y => {
        if ($0.tag === "Nothing") { return y.tag === "Nothing"; }
        if ($0.tag === "Just") {
          if (y.tag === "Just") {
            if ($0._1.tag === "ProductItem") {
              if (y._1.tag === "ProductItem") { return $0._1._1 === y._1._1; }
              return false;
            }
            if ($0._1.tag === "ComboItem") {
              if (y._1.tag === "ComboItem") { return $0._1._1 === y._1._1; }
              return false;
            }
            return false;
          }
          return false;
        }
        return false;
      };
    })())(Data$dFunctor.arrayMap(Data$dMaybe.Just)(v._1));
  }
  if (v.tag === "ProductCategoryIdFilter") {
    return Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v$1 => v1 => v$1 || v1})})((() => {
      const $0 = product.productCategoryId;
      return y => {
        if ($0.tag === "Nothing") { return y.tag === "Nothing"; }
        if ($0.tag === "Just") {
          if (y.tag === "Just") { return $0._1 === y._1; }
          return false;
        }
        return false;
      };
    })())(Data$dFunctor.arrayMap(Data$dMaybe.Just)(v._1));
  }
  if (v.tag === "ParameterValueFilter") {
    return Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v$1 => v1 => v$1 || v1})})((() => {
      const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._1)(product.customParameters);
      return y => {
        if ($0.tag === "Nothing") { return y.tag === "Nothing"; }
        if ($0.tag === "Just") {
          if (y.tag === "Just") { return $0._1 === y._1; }
          return false;
        }
        return false;
      };
    })())(Data$dFunctor.arrayMap(Data$dMaybe.Just)(v._2));
  }
  if (v.tag === "AnyComboFilter") { return product.isCombo; }
  $runtime.fail();
};
const inProductFilter = productItem => Data$dFoldable.foldableArray.foldMap({mempty: true, Semigroup0: () => ({append: v => v1 => v && v1})})(inProductSingleFilter(productItem));
export {inProductFilter, inProductSingleFilter};
